import {useTheme} from '@mui/material';

import IconNamesType from 'presentation/icons/IconNamesType';
import {HistoryFilterEnum} from 'presentation/modules/myAppointments/constants/historyFilterEnum';

type VariantType = 'warning' | 'error' | 'success' | 'info' | 'primary' | 'secondary' | 'default';

type HistoryTheme = {
	iconName: IconNamesType;
	iconColor: string;
	bgColor?: string;
	color: string;
	variant: VariantType;
};

type UseHistoryTheme = {
	historyFilter: HistoryFilterEnum;
};

export function useHistoryTheme({historyFilter}: UseHistoryTheme) {
	const theme = useTheme();

	const historyTheme: Record<HistoryFilterEnum, HistoryTheme> = {
		[HistoryFilterEnum.HEALTH]: {
			iconName: 'stethoscope',
			iconColor: theme.palette.primary.dark,
			bgColor: theme.palette.primary.shades?.['30p'],
			color: theme.palette.primary.main,
			variant: 'primary',
		},
		[HistoryFilterEnum.TELEHEALTH]: {
			iconName: 'remember-me-filled',
			iconColor: theme.palette.primary.dark,
			bgColor: theme.palette.primary.shades?.['30p'],
			color: theme.palette.primary.main,
			variant: 'primary',
		},
		[HistoryFilterEnum.EMERGENCY]: {
			iconName: 'local-hospital-filled',
			iconColor: theme.palette.primary.dark,
			bgColor: theme.palette.primary.shades?.['30p'],
			color: theme.palette.primary.main,
			variant: 'primary',
		},
		[HistoryFilterEnum.SURGERY]: {
			iconName: 'surgical',
			iconColor: theme.palette.primary.dark,
			bgColor: theme.palette.primary.shades?.['30p'],
			color: theme.palette.primary.main,
			variant: 'primary',
		},
	};

	return historyTheme[historyFilter];
}
